/* src/app/modules/shared/components/header-column/header-column-terpene/header-column-terpene.component.scss */
app-header-column-terpene {
  display: contents;
}
/*# sourceMappingURL=header-column-terpene.component.css.map */
